const StatementMessageType = [
    {
        value : 'text',
        text : 'Text'
    },
    {
        value : 'raw',
        text : 'Raw Message'
    }
]

export default StatementMessageType;